<template>
  <div class="content">
    <!-- <h3 ref="pageHeader" class="pageHeader">首页</h3> -->
    <!-- <div class="carousel">
      <el-carousel ref="carousel" trigger="click" :height="cheight" width="100%">
        <template v-if="swipes.length">
          <el-carousel-item v-for="item in swipes" :key="item.id">
            <div class="entry" :style="{ backgroundImage: `url(${item.file})` }">
              <el-image :src="item.file" ref="innerImg" style="visibility: hidden;width:98%"></el-image>
            </div>
          </el-carousel-item>
        </template>
<el-carousel-item v-else>
  <div class="entry" style="background-image: url('../../assets/image/swipe1.png');">
    <el-image src="../../assets/image/swipe1.png" ref="innerImg" style="visibility: hidden;width:98%"></el-image>
  </div>
</el-carousel-item>
</el-carousel>
</div> -->
    <div class="flex-div" style="margin-bottom: 6px;">
      <div class="top-item">
        <div class="icon-div">
          <img src="@/assets/image/index/实验实训室.svg" style="background-color: var(--lightYellow);" />
        </div>
        <el-card shadow="always">
          <div class="num" style="color:var(--lightYellow);">{{ counts.room }}</div>
          <div class="label">{{ $store.state.themeTitle }}室</div>
        </el-card>
      </div>
      <div class="top-item">
        <div class="icon-div">
          <img src="@/assets/image/index/实验实训计划.svg" style="background-color: var(--lightRed);" />
        </div>
        <el-card shadow="always">
          <div class="num" style="color:var(--lightRed);">{{ counts.plan }}</div>
          <div class="label">{{ $store.state.themeTitle }}计划</div>
        </el-card>
      </div>
      <div class="top-item">
        <div class="icon-div">
          <img src="@/assets/image/index/课程数量.svg" style="background-color: var(--cyan);" />
        </div>
        <el-card shadow="always">
          <div class="num" style="color:var(--cyan);">{{ counts.class }}</div>
          <div class="label">课程数量</div>
        </el-card>
      </div>
      <div class="top-item">
        <div class="icon-div">
          <img src="@/assets/image/index/仪器设备.svg" style="background-color:  var(--grayGreen);" />
        </div>
        <el-card shadow="always">
          <div class="num" style="color:var(--grayGreen);">{{ counts.device }}</div>
          <div class="label">仪器设备</div>
        </el-card>
      </div>
      <div class="top-item">
        <div class="icon-div">
          <img src="@/assets/image/index/易耗品.svg" style="background-color: var(--grayBlue);" />
        </div>
        <el-card shadow="always">
          <div class="num" style="color:var(--grayBlue);">{{ counts.consumed }}</div>
          <div class="label">易耗品</div>
        </el-card>
      </div>
    </div>
    <div class="flex-box">
      <div class="f-item" style="width: 40%;">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span><i class="el-icon-message-solid" style="margin-right: 2px;"></i>个人信息</span>
            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
          </div>
          <ul class="ul-style" style="padding:8px;">
            <li class="item" style="color:var(--blue)">
              <p class="p-title">姓&nbsp;&nbsp;&nbsp;&nbsp;名：</p>
              <p class="p-content">{{ userInfo.name }}</p>
            </li>
            <li class="item">
              <p class="p-title">工号/学号：</p>
              <p class="p-content">{{ userInfo.number }}</p>
            </li>
            <li class="item">
              <p class="p-title">用户类型：</p>
              <p class="p-content">{{ userType }}</p>
            </li>
            <li class="item">
              <p class="p-title">组织结构：</p>
              <p class="p-content">{{ userInfo.defaultStructure ? userInfo.defaultStructure.name : '' }}</p>
            </li>
            <li class="item">
              <p class="p-title">上次登录时间：</p>
              <p class="p-content">{{ userInfo.login_time }}</p>
            </li>
          </ul>
        </el-card>
      </div>
      <div class="f-item" style="width: 60%;">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span><i class="el-icon-s-grid" style="margin-right: 2px;"></i>我的实训课表</span>
            <el-button style="float: right; padding: 3px 0" type="text"
              @click="handlePathClick('/courseManage')">查看更多</el-button>
          </div>
          <div class="flex-box">
            <template v-if="courses && courses.length > 0">
              <ul class="ul-style" style="width: 50%;padding:0 13px;">
                <li class="item" style="color:var(--blue)">
                  <p class="p-top">我的课程1</p>
                </li>
                <li class="item" style="color:var(--blue)">
                  <p class="p-title">课程名称：</p>
                  <p class="p-content">{{ courses[0].course_name }}</p>
                </li>
                <li class="item">
                  <p class="p-title">上课专业：</p>
                  <p class="p-content">{{ courses[0].structure_2 }}</p>
                </li>
                <li class="item">
                  <p class="p-title">上课班级：</p>
                  <p class="p-content">{{ courses[0].class_name }}</p>
                </li>
                <li class="item">
                  <p class="p-title">实训室名称：</p>
                  <p class="p-content">{{ courses[0].training_name }}</p>
                </li>
                <li class="item">
                  <p class="p-title">周&nbsp;&nbsp;&nbsp;&nbsp;次：</p>
                  <p class="p-content">{{ courses[0].week }}</p>
                </li>
                <li class="item">
                  <p class="p-title">星&nbsp;&nbsp;&nbsp;&nbsp;期：</p>
                  <p class="p-content">{{ courses[0].xq }}</p>
                </li>
              </ul>
              <ul v-if="courses[1]" class="ul-style" style="width: 50%;padding:0 13px;">
                <li class="item" style="color:var(--blue)">
                  <p class="p-top">我的课程2</p>
                </li>
                <li class="item" style="color:var(--blue)">
                  <p class="p-title">课程名称：</p>
                  <p class="p-content">{{ courses[1].course_name }}</p>
                </li>
                <li class="item">
                  <p class="p-title">上课专业：</p>
                  <p class="p-content">{{ courses[1].structure_2 }}</p>
                </li>
                <li class="item">
                  <p class="p-title">上课班级：</p>
                  <p class="p-content">{{ courses[1].class_name }}</p>
                </li>
                <li class="item">
                  <p class="p-title">实训室名称：</p>
                  <p class="p-content">{{ courses[1].training_name }}</p>
                </li>
                <li class="item">
                  <p class="p-title">周&nbsp;&nbsp;&nbsp;&nbsp;次：</p>
                  <p class="p-content">{{ courses[1].week }}</p>
                </li>
                <li class="item">
                  <p class="p-title">星&nbsp;&nbsp;&nbsp;&nbsp;期：</p>
                  <p class="p-content">{{ courses[1].xq }}</p>
                </li>
              </ul>
              <ul v-else class="ul-style" style="width: 50%;padding:0 13px;">
                <li>
                  <el-empty description="暂无课程" style="width: 100%;"></el-empty>
                </li>
              </ul>
            </template>
            <el-empty v-else description="暂无课程" style="width: 100%;"></el-empty>
          </div>
        </el-card>
      </div>
      <!-- <div class="f-item" style="width: 10%;" @click="handleWindowOpen('/dataCenter')">
        <el-card class="box-card">
          <div class="float-text"><span>点击查看数据大屏</span> <i class="el-icon-d-arrow-right"></i></div>
        </el-card>
      </div> -->
    </div>
    <div class="flex-box">
      <div class="f-item" style="width: 60%;">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span><i class="el-icon-s-grid" style="margin-right: 2px;"></i>{{ $store.state.themeTitle }}室安全</span>
            <!-- <el-button style="float: right; padding: 3px 0" type="text" @click="handlePathClick('/courseManage')">查看更多</el-button> -->
          </div>
          <div class="flex-box">
            <div class="table-title" style="background: var(--lightYellow);">安全隐患整改
              <el-button type="text" @click="handlePathClick('/troubles')">查看更多</el-button>
            </div>
            <div class="table-content">
              <custom-table v-if="tableData && tableData.length > 0" :data="tableData" style="width: 100%">
                <custom-table-column prop="record_name" align="center" :show-overflow-tooltip="true" label="检查名称">
                </custom-table-column>
                <custom-table-column prop="structure_1" align="center" :show-overflow-tooltip="true" label="检查院系">
                </custom-table-column>
                <custom-table-column prop="training_room_name" align="center" :show-overflow-tooltip="true"
                  :label="`${$store.state.themeTitle}室`">
                </custom-table-column>
                <custom-table-column label="隐患状态" align="center" :show-overflow-tooltip="true" prop="trouble_status"
                  label-class-name="troubleStatus" :formatter="format_arr">
                </custom-table-column>
              </custom-table>
              <el-empty v-else description="暂无隐患" style="width: 100%;"></el-empty>
            </div>
            <div class="table-title" style="background: var(--ligtGreen);">安全检查活动
              <el-button type="text" @click="handlePathClick('/checkActivities')">查看更多</el-button>
            </div>
            <div class="table-content">
              <custom-table v-if="tableData1 && tableData1.length > 0" :data="tableData1" style="width: 100%">
                <custom-table-column fixed prop="name" align="center" :show-overflow-tooltip="true" label="巡查活动名称">
                </custom-table-column>
                <custom-table-column prop="target_type" align="center" :show-overflow-tooltip="true" label="巡查对象">
                  <template slot-scope="scope">
                    <span v-if="scope.row.target_type == '0'">全校</span>
                    <span v-if="scope.row.target_type == '1'">院系</span>
                    <span v-if="scope.row.target_type == '2'">{{ $store.state.themeTitle }}室</span>
                  </template>
                </custom-table-column>
                <custom-table-column prop="start_time" align="center" :show-overflow-tooltip="true" label="开始时间">
                </custom-table-column>
                <custom-table-column prop="end_time" align="center" :show-overflow-tooltip="true" label="结束时间">
                </custom-table-column>
              </custom-table>
              <el-empty v-else description="暂无活动" style="width: 100%;"></el-empty>
            </div>
          </div>
        </el-card>
      </div>
      <div class="f-item" style="width: 40%;">
        <el-card class="box-card" style="height: 100%;">
          <div slot="header" class="clearfix">
            <span><i class="el-icon-message-solid" style="margin-right: 2px;"></i>通知公告</span>
            <el-button style="float: right; padding: 3px 0" type="text"
              @click="handlePathClick('/notice')">查看更多</el-button>
          </div>
          <template v-if="notices && notices.length > 0">
            <ul class="ul-style" style="padding:8px;">
              <li class="item" v-for="item in notices" :key="item.id">
                <p class="p-l">{{ item.title }}</p>
                <p class="p-r">{{ item.created_at }}</p>
              </li>
            </ul>
          </template>
          <el-empty v-else description="暂无通知" style="width: 100%;"></el-empty>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import CustomTable from "@/components/CustomTable";
import CustomTableColumn from "@/components/CustomTableColumn";
export default {
  name: 'demoEchart',
  mixins: [mixinFormatter],
  data() {
    return {
      notice: {
        page: 0,
        size: 15,
        total: 0,
        tableData: [],
      },
      notices: [],
      file: {
        page: 0,
        size: 10,
        total: 0,
        tableData: [],
      },
      cheight: '330px',
      message: {
        query: false,
        tableData: [],
      },
      swipes: [],
      counts: {},
      offsetHeight: '500px',
      scrollHeight: '400px',
      userInfo: {
        name: '',
        number: '',
        defaultStructure: {
          name: '',
        },
        login_time: '',
      },
      tableData: [],
      tableData1: [],
      courses: [],
    };
  },
  components: {
    // 'v-chart': ECharts,
    CustomTableColumn,
    CustomTable,
  },
  created() {
    // this.getBanners();
    this.geCounts();
    this.userInfo = this.$store.state.userInfo;
    this.$store.dispatch('getPosts');
    this.getClasses();
    this.getNoticeList();
    this.geSafes();
    this.geChecks();
  },
  mounted() {
    this.offsetHeight = document.body.offsetHeight - 116 + 'px';
    this.scrollHeight = document.body.offsetHeight - 116 - 50 - 56 - 43 - 204 - 38 + 'px';
    // console.log(this.scrollHeight);
    // this.getStudentApply()
    // this.getProvince()
    // this.cheight = (this.$refs.carousel.$el.offsetWidth / 1920) * 460 + 'px';
    // window.onresize = ()=> {
    //   this.cheight = (this.$refs.carousel.$el.offsetWidth / 1920) * 460 + 'px';
    // };
  },
  computed: {
    userType: function () {
      let usertype = '';
      if (this.$store.state.posts && this.$store.state.posts.length > 0) {
        this.$store.state.posts.map((item) => {
          if (item.value == this.userInfo.usertype) {
            usertype = item.label;
          }
        });
      }
      return usertype;
    },
  },
  methods: {
    async geCounts() {
      let params = {};
      let res = await this.$api.instance.interfaceServer(`api/index/count`, 'get', params);
      if (res.code == 0) {
        this.counts = res.data;
        // this.swipes = res.data;
        // this.srcList = res.data.map((item) => {
        //   return item.file;
        // });
      }
    },
    async geSafes() {
      let params = {
        page: 1,
        size: 5,
        trouble_status: 0,
      };
      let res = await this.$api.instance.interfaceServer(`api/safety_check/trouble/list`, 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
      }
    },
    async geChecks() {
      let res = await this.$api.instance.interfaceServer(`api/safety_check/activity/list/all`, 'get');
      if (res.code == 0 && res.data) {
        this.tableData1 = res.data.slice(0, 5);
      }
    },
    async getClasses() {
      let params = {
        status: 'pass',
      };
      params.page = 1;
      params.size = 2;
      let res = await this.$api.query.getClassPlanList(params);
      if (res.code == 0 && res.data) {
        this.courses = res.data.data;
      }
    },
    handleWindowOpen(path) {
      if (this.$store.state.userInfo.schoolid == 1) {
        window.open(`${location.origin}/#${path}`)

      } else {
        this.$message.info('功能暂未开放！')
      }
    },
    handlePathClick(path) {
      this.$router.push({
        path,
      });
    },
    // async getBanners() {
    //   let params = {};
    //   let res = await this.$api.instance.interfaceServer(`api/banner`, 'get', params);
    //   if (res.code == 0) {
    //     this.swipes = res.data;
    //     this.srcList = res.data.map((item) => {
    //       return item.file;
    //     });
    //   }
    // },
    hadleFileClick(url) {
      const link = document.createElement('a');
      let fname = this.downloadName;
      link.href = url;
      link.setAttribute('download', fname);
      document.body.appendChild(link);
      link.click();
    },
    async getNoticeList() {
      let params = {
        page: 1,
        size: 15,
      };
      let res = await this.$api.query.getNoticesUnload(params);
      if (res.code == 0 && res.data) {
        this.notices = res.data.data;
      }
    },
    async getFileList() {
      let params = {
        page: this.file.page,
        size: this.file.size,
      };
      let res = await this.$api.query.getFilesUnload(params);
      if (res.code == 0 && res.data) {
        this.file.tableData = this.file.tableData.concat(res.data.data);
        this.file.total = res.data.total;
      }
    },
    async getMessageList() {
      let params = {
        count: 9999,
      };
      let res = await this.$api.instance.getNewMessages(params);
      if (res.code == 0 && res.data) {
        this.message.tableData = this.message.tableData.concat(res.data);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.entry {
  background: var(--bule);

  // background-position: center center;
  width: 100%;
  height: 100%;
  background-size: cover;
  // background-size: 100% auto;
  // background-repeat: no-repeat;
  // padding-bottom: 50%;
}

.carousel {
  box-shadow: 0 2px 12px 0 #11111147;
  width: calc(100% - 6px);
  margin: 0 auto;
}

// /deep/ .el-carousel__item {
//   display: block;
//   position: relative;
// }

.item {
  margin-bottom: 14px;
  width: calc(100% - 10px);
}

.table-title {
  width: 100%;
  text-align: center;
  color: #fff;
  padding: 8px;
  position: relative;

  /deep/.el-button {
    color: var(--white);
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
  }

  /deep/.el-button:hover {
    color: var(--lightBlue);
  }
}

.table-content {
  width: 100%;

  /deep/.el-empty {
    padding: 16px;

    /deep/.el-empty__image {
      width: 80px;
    }
  }
}

/deep/.el-col-8 {
  padding: 0 8px;
  height: 100%;
}

/deep/.el-card {
  height: calc(100% - 40px);
  border-radius: 16px;
}

/deep/.el-card__header {
  border: 0;
  font-size: 18px;
  color: #777;
  font-weight: bold;
  letter-spacing: 1.3px;
  padding: 20px 24px 8px;
}

/deep/.el-row {
  margin-top: 16px;
}

/deep/.el-empty {
  padding: 0;
}

.flex-div {
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  .top-item {
    width: 20%;
    padding: 8px 2px 4px;
    box-sizing: border-box;

    .icon-div {
      height: 40px;
      position: relative;

      img {
        width: 36px;
        position: absolute;
        top: 8px;
        right: 50%;
        padding: 10px;
        border-radius: 8px;
        transform: translateX(50%);
        box-shadow: 2px 2px 4px 1px var(--gray);
      }
    }

    /deep/.el-card {
      margin: 0 8px;
    }

    /deep/.el-card__body,
    .el-main {
      padding: 20px 20px;
    }

    .num {
      font-size: 36px;
      font-weight: bold;
      text-align: center;
      padding: 16px 0 8px;
      // text-shadow: 2px 2px 4px var(--lightGray);
    }

    .label {
      font-size: 17px;
      color: #555;
      font-weight: bold;
      letter-spacing: 1.3px;
      text-align: center;
      text-shadow: 2px 2px 4px var(--lightGray);
    }
  }
}

.flex-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  .f-item {
    min-height: 360px;
    padding: 10px;
    box-sizing: border-box;

    /deep/.el-card {
      height: 100%;
    }

    .ul-style {
      list-style: none;
      padding: 8px;
      box-sizing: border-box;

      li {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        margin-bottom: 16px;
        padding: 0 8px;

        .p-top {
          width: 100%;
          text-align: center;
          background-color: var(--grayBlue);
          color: var(--white);
          font-size: 15px;
          font-weight: bold;
          padding: 4px 32px;
          margin: 0 auto 6px;
          border-radius: 15px;
        }

        .p-title {
          width: 120px;
          font-weight: bold;
          text-align: left;
          text-indent: 8px;
        }

        .p-content {
          flex: 1;
        }

        .p-l {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          flex: 1;
        }

        // .p-l:hover {
        //   color: var(--blue);
        //   text-decoration: underline;
        // }

        .p-r {
          color: var(--gray);
          text-align: right;
          font-size: 12px;
          width: 120px;
        }
      }
    }
  }
}

.pageHeader {
  margin-bottom: 12px;
}

.pageHeader:before {
  width: 64px;
}

@media screen and (min-width: 1000px) {}

/* 针对手机的样式 */
@media screen and (max-width: 1000px) {
  .icon-div img {
    width: 24px !important;
  }

  .top-item .num {
    font-size: 16px !important;
  }

  .top-item .label {
    padding: 0 8px;
    font-size: 18px !important;
  }

  /deep/.el-card__body {
    padding: 20px 4px !important;
  }

  .f-item {
    width: 100% !important;
  }


}

// .float-text {
//   text-align: center;
//   font-size: 20px;
//   width: 20px;
//   margin: 0 auto;
//   height: inherit;
// }
.float-text {
  height: inherit;
  display: flex;
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中（可选） */
  font-size: 18px;
  letter-spacing: 1.5px;
  cursor: pointer;
  position: relative;
}

.float-text span {
  writing-mode: vertical-rl;
  /* 纵向排列：从右向左 */
  text-orientation: mixed;
  /* 控制文字方向，mixed 表示保持原方向 */
  white-space: nowrap;
  /* 防止换行 */
}

.float-text i {
  position: absolute;
  right: -8px;
}

/deep/.el-card__body {
  height: inherit;
  box-sizing: border-box;
}
</style>
